import React from "react";
import { Card, Avatar, Tooltip, Col, Row } from "antd";
import { connect, useSelector } from "react-redux";
import Mail from "../../src/assets/Mail.svg";
import ViewMore from "organisms/ViewMore";
import {
  getUserName,
  getUserRoleId,
  getUnreadChatMessageList,
  getUserInfo,
  getRoleList,
  getAllDepartmentList,
} from "redux/selectors";
import styled from "@emotion/styled";
import { startCase } from "lodash";
import COLORS from "common/Colors";
import { useTranslation } from "react-i18next";

const StyledCard = styled(Card)`
  height: 100%; /* let the card fill its grid cell */

  .contract_style {
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .contract_text {
    width: 120px;
    height: 24px;
    font-family: "DM Sans", sans-serif;
    font-weight: 550;
    font-size: 14px;
    color: #2d53da;
    background-color: #e3e8fc;
    border-radius: 0px 0px 8px 0px;
  }
  .ant-card-body {
    padding: 0px;
    height: 100%;
  }
  .ant-card-bordered {
    border-radius: 10px !important;
  }
  .vert_Icon {
    color: #2d53da;
  }
  .first_row_styl {
    display: flex;
  }
  .thin-hr {
    border: none;
    height: 0.1px;
    background-color: black;
  }

  .threedot {
    position: absolute;
    top: 10px;
    right: 15px;
    cursor: pointer;
  }
  .StyledImage {
    background-color: transparent;
    vertical-align: middle;
  }
  .employee-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 20px;
    background-color: white;
    border-radius: 10px;
    gap: 3px;
    box-shadow: 0px 4px 27px 0px #00000017;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    height: 100%; /* fill the card, so all cards in a row match */
    box-sizing: border-box;

    .chat-container {
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background-color: ${COLORS.PRIMARY};
      translate: 50% -50%;
      .chat-icon {
        translate: 20px 55px;
      }
    }
    .icon {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;
      .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .name {
      font-size: 16px;
      font-weight: 600;
      margin-top: 4px;
      min-height: 44px; /* reserves space for 2 lines so 1-line names don't shrink the card */
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      line-height: 1.3;
    }
    .department {
      font-size: 14px;
      margin-top: 8px;
      place-self: flex-start;
      .bold {
        color: #636980 !important;
      }
    }
    .position {
      font-size: 14px;
      place-self: flex-start;
      .bold {
        font-weight: 400;
        color: #636980;
      }
    }
  }
`;

const StyledAvatar = styled(Avatar)`
  background-color: ${COLORS.PRIMARY};
  vertical-align: middle;
  font-size: 3rem;
  height: 74px;
  width: 74px;
  text-align: center;
  margin-top: 10px;
  .ant-avatar-string {
    margin-top: 1rem;
  }
`;

function TeamCard({
  id,
  name,
  profile,
  employeeid,
  jobtitle,
  usertype,
  employementtype,
  nationality,
  basedepartmentid,
}) {
  const { t } = useTranslation();
  const departmentList = useSelector(getAllDepartmentList);

  return (
    <>
      <StyledCard>
        <div className="employee-card">
          <Row>
            <Col className="contract_style">
              <div className="contract_text text-center">
                {t(employementtype)}
              </div>
            </Col>
          </Row>
          {profile === null ||
          profile === "" ||
          profile === undefined ||
          profile === "null" ? (
            <StyledAvatar size="default">
              {startCase(name?.charAt(0))}
            </StyledAvatar>
          ) : (
            <StyledAvatar
              src={profile}
              className="StyledImage"
              size="default"
            ></StyledAvatar>
          )}
          <div className="name">
            {" "}
            <Tooltip title={name}>{name}</Tooltip>
          </div>
          <hr className="thin-hr w-100"></hr>
          <div className="position">
            <span className="bold">{t("Employee ID")}</span>:{" "}
            {employeeid || "-"}
          </div>
          <div className="position">
            <span className="bold">{t("department")}</span>:{" "}
            {
              departmentList?.find(
                (item) => item?.department_id === basedepartmentid
              )?.department_name
            }
          </div>
          <div className="position">
            <span className="bold">{t("Type")}</span>: {t(usertype)}
          </div>
        </div>
      </StyledCard>
    </>
  );
}

const mapStateToProps = (state) => ({
  userName: getUserName(state),
  userRoleId: getUserRoleId(state),
  unreadChatMessageList: getUnreadChatMessageList(state),
  userInfo: getUserInfo(state),
  roleList: getRoleList(state),
});

export default connect(mapStateToProps, null)(TeamCard);
